import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const lessonEditorManifest: FeatureManifest = {
  id: 'lesson-editor',
  path: 'lessons/:lessonId/editor/*',
  navPath: '/lessons/catalog',
  label: 'Biên soạn bài học',
  description: 'Không gian biên soạn bài học',
  hideFromNavigation: true,
  load: () => import('./entry'),
}
